<template>
    <CustomModal
      v-if="isOpen"
      id="no-licence-modal"
      class="basic-modal no-header-modal hide-cancel-btn content-report-modal"
      :hide-header="true"
      :ok-title="$t('common.confirm')"
      :hideFooter="true"
    >
      <section class="pb-10">
        <h4
          v-if="isSolvedFreeQuizzes"
          class="typography-subtitle-1 typography-color-black text-center"
        >
          <template v-if="isNoSchoolLicence && allowedQuizzesCount > 0">
            {{ allowedQuizzesCount }}개의 문항을 모두 소진하였습니다.
            <br />
            학교 선생님에게 문의하세요.
            <br />
            (할당된 문항은 매월 초기화됩니다)
          </template>
          <template v-else-if="isNoSchoolLicence">
            할당된 문항을 모두 소진하였습니다.
            <br />
            학교 선생님에게 문의하세요.
            <br />
            (할당된 문항은 매월 초기화됩니다)
          </template>
          <template v-else>
            해당 콘텐츠를 계속 학습하고 싶다면?
            <br />
            클래스팅 AI 이용권을 구매해 보세요.
          </template>
        </h4>
        <h4
          v-else
          class="typography-subtitle-1 typography-color-black text-center"
        >
          AI 이용권이 없습니다.
        </h4>
        <img
          class="mx-auto d-block pb-20"
          src="@/assets/images/ic_free_done.svg"
        />
        <button
          type="button"
          class="btn btn-lg btn-block licence-purchase-button"
          @click="handleLicencePurchaseClick()"
        >
          <strong class="typography-subtitle-1">
            AI 구매하고 무제한 학습하기
          </strong>
        </button>
        <button
          type="button"
          class="btn btn-lg btn-block licence-purchase-close-button"
          @click="$emit('onCloseClick')"
        >
          <strong class="typography-subtitle-1">
            닫기
          </strong>
        </button>
      </section>
    </CustomModal>
</template>

<script>
import quiz from '@/mixins/quiz';

export default {
  name: 'cat-no-licence-modal',

  mixins: [
    quiz,
  ],

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    isSolvedFreeQuizzes: {
      type: Boolean,
      default: false,
    },
    isNoSchoolLicence: {
      type: Boolean,
      default: false,
    },
    allowedQuizzesCount: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  .licence-purchase-button {
    color: #ffffff;
    background-image: linear-gradient(to right, #4823ae, #c86dd7 84%);
  }

  .licence-purchase-close-button {
    color: #30e3b8;
    background-color: rgba(0, 0, 0, 0.8);
  }
</style>
